<template>
  <div>
    <div v-for="(rule, index) in majorityConditions.rules" :key="index">
      <b-badge v-if="index !== 0" variant="primary" class="m-2">
        {{ rulesOperatorsOptions.find(o => o.value === majorityConditions.rulesOperator).text }}
      </b-badge>
      <b-alert class="m-0" show variant="warning">
        <div>
          {{ majorityTypeOptions.find(o => o.value === rule.majorityType).text }}
        </div>
        <div>
          {{ forOrAgainstOptions.find(o => o.value === rule.forOrAgainst).text }}
        </div>
        <div>
          {{ operatorsOptions.find(o => o.value === rule.operators).text }}
        </div>
        <div>{{ rule.percent }} %</div>
        <div>
          {{ denominatorOptions.find(o => o.value === rule.denominator).text }}
        </div>
        <div v-if="rule.majorityType == '2'">
          {{ cumulMandatesOptions.find(o => o.value === rule.cumulMandates).text }}
        </div>
      </b-alert>
    </div>
    <b-badge class="m-2" :variant="majorityConditions.revote ? 'success' : 'light'">
      Revote : {{ majorityConditions.revote ? "vraie" : "faux" }}
    </b-badge>
  </div>
</template>

<script>
import {
  majorityTypeOptions,
  forOrAgainstOptions,
  cumulMandatesOptions,
  operatorsOptions,
  denominatorOptions,
  rulesOperatorsOptions,
} from "@/constants/majority.js";

export default {
  props: {
    majority: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      majorityTypeOptions,
      forOrAgainstOptions,
      cumulMandatesOptions,
      operatorsOptions,
      denominatorOptions,
      rulesOperatorsOptions,
      majorityConditions: {},
    };
  },
  created() {
    this.majorityConditions = this.majority.majority_conditions;
  },
};
</script>
